(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ex-loyalty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      var root = document.getElementById('xloyalty');
      if (!root) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
      root.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

      root.querySelectorAll('#xl-faq .q').forEach(function (q) {
        var btn = q.querySelector('button');
        var a = q.querySelector('.a');
        btn.addEventListener('click', function () {
          var open = q.classList.contains('open');
          root.querySelectorAll('#xl-faq .q.open').forEach(function (o) {
            o.classList.remove('open');
            o.querySelector('.a').style.maxHeight = '0';
          });
          if (!open) {
            q.classList.add('open');
            a.style.maxHeight = a.scrollHeight + 'px';
          }
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ex-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.exRevOn) return;
      root.dataset.exRevOn = '1';

      var track = root.querySelector('[data-ex-rev-track]');
      var bar = root.querySelector('[data-ex-rev-bar]');
      if (!track) return;
      var cards = track.querySelectorAll('.ex-rev__card');
      if (!cards.length) return;

      var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wait = (parseFloat(root.dataset.autoplay) || 5) * 1000;
      var timer = null;
      var hover = false;
      var touched = false;
      var seen = true;

      // Die Leiste ist so breit wie der sichtbare Anteil der Bahn und wandert
      // anteilig mit. translateX rechnet in Prozent der eigenen Breite.
      function paint() {
        if (!bar) return;
        var span = track.scrollWidth - track.clientWidth;
        var w = Math.max((track.clientWidth / track.scrollWidth) * 100, 12);
        var p = span > 0 ? track.scrollLeft / span : 0;
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (p * (100 - w) * 100) / w + '%)';
      }

      function step() {
        var span = track.scrollWidth - track.clientWidth;
        if (span <= 1) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
        var next = track.scrollLeft + cards[0].getBoundingClientRect().width + gap;
        if (next > span - 4) next = 0;
        track.scrollTo({ left: next, behavior: slow ? 'auto' : 'smooth' });
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function run() {
        stop();
        if (slow || hover || touched || !seen) return;
        if (track.scrollWidth - track.clientWidth <= 1) return;
        timer = setInterval(step, wait);
      }

      var resume = null;
      function pause(ms) {
        touched = true;
        stop();
        if (resume) clearTimeout(resume);
        resume = setTimeout(function () {
          touched = false;
          run();
        }, ms);
      }

      track.addEventListener('scroll', paint, { passive: true });
      track.addEventListener('pointerenter', function () { hover = true; stop(); });
      track.addEventListener('pointerleave', function () { hover = false; run(); });
      track.addEventListener('pointerdown', function () { pause(4000); });
      track.addEventListener('touchstart', function () { pause(4000); }, { passive: true });
      track.addEventListener('focusin', function () { hover = true; stop(); });
      track.addEventListener('focusout', function () { hover = false; run(); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          seen = e[0].isIntersecting;
          run();
        }, { threshold: 0.2 }).observe(root);
      }

      window.addEventListener('resize', paint);
      paint();
      run();
    }

    function boot() {
      var list = document.querySelectorAll('[data-ex-rev]');
      for (var i = 0; i < list.length; i++) init(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
